// Dimensions section: top-down ski diagram drawn from the selected size's
// tip/waist/tail widths, plus click-a-row-to-pick-that-length. Stays in sync
// with the buy-box picker through Dawn's pubsub variantChange event.
(() => {
  const section = document.querySelector('[data-dimensions-section]');
  if (!section) return;

  const rows = [...section.querySelectorAll('.dimensions-table tbody tr[data-variant-id]')];
  const plan = section.querySelector('[data-ski-plan]');
  const shape = plan && plan.querySelector('[data-ski-shape]');
  const measures = plan && plan.querySelector('[data-ski-measures]');
  const SVG_NS = 'http://www.w3.org/2000/svg';

  // SVG geometry (viewBox 0 0 600 80). Widths are exaggerated around a 60mm
  // baseline so the sidecut actually reads at this size - it's a shape
  // guide, not a scale drawing. The range is freestyle twin tips, so the
  // outline is mirrored about the waist: identical rounded ends, contact
  // points the same distance in from each end. Only the measured widths
  // (tip vs tail) can differ.
  const CY = 40;
  const LENGTH = 600;
  const END = 4; // gap from viewBox edge to the rounded end
  const CONTACT = 70; // widest point, measured in from each end
  const X = { nose: END, tip: CONTACT, waist: LENGTH / 2, tail: LENGTH - CONTACT, end: LENGTH - END };
  const half = (mm) => Math.max(6, (Number(mm) - 60) * 0.42);

  const pathFor = (tip, waist, tail) => {
    const t = half(tip);
    const w = half(waist);
    const l = half(tail);
    const top = [
      `M ${X.nose} ${CY}`,
      `C ${X.nose} ${CY - t * 0.9}, ${X.tip - 40} ${CY - t}, ${X.tip} ${CY - t}`,
      `C ${X.tip + 90} ${CY - t}, ${X.waist - 110} ${CY - w}, ${X.waist} ${CY - w}`,
      `C ${X.waist + 110} ${CY - w}, ${X.tail - 90} ${CY - l}, ${X.tail} ${CY - l}`,
      `C ${X.tail + 40} ${CY - l}, ${X.end} ${CY - l * 0.9}, ${X.end} ${CY}`,
    ];
    const bottom = [
      `C ${X.end} ${CY + l * 0.9}, ${X.tail + 40} ${CY + l}, ${X.tail} ${CY + l}`,
      `C ${X.tail - 90} ${CY + l}, ${X.waist + 110} ${CY + w}, ${X.waist} ${CY + w}`,
      `C ${X.waist - 110} ${CY + w}, ${X.tip + 90} ${CY + t}, ${X.tip} ${CY + t}`,
      `C ${X.tip - 40} ${CY + t}, ${X.nose} ${CY + t * 0.9}, ${X.nose} ${CY}`,
      'Z',
    ];
    return top.concat(bottom).join(' ');
  };

  // Dotted leader from the callout label (above the SVG) down to the ski's
  // edge, then a solid capped bar across the ski's width at that point.
  const line = (cls, x1, y1, x2, y2) => {
    const el = document.createElementNS(SVG_NS, 'line');
    el.setAttribute('class', cls);
    el.setAttribute('x1', x1);
    el.setAttribute('y1', y1);
    el.setAttribute('x2', x2);
    el.setAttribute('y2', y2);
    return el;
  };

  const drawMeasures = (tip, waist, tail) => {
    if (!measures) return;
    measures.replaceChildren();
    [
      [X.tip, half(tip)],
      [X.waist, half(waist)],
      [X.tail, half(tail)],
    ].forEach(([x, h]) => {
      const top = CY - h;
      const bottom = CY + h;
      measures.append(
        line('ski-plan__leader', x, -4, x, top - 3),
        line('ski-plan__measure', x, top + 2, x, bottom - 2),
        line('ski-plan__measure-cap', x - 5, top + 2, x + 5, top + 2),
        line('ski-plan__measure-cap', x - 5, bottom - 2, x + 5, bottom - 2)
      );
    });
  };

  const render = (row) => {
    if (!row || !plan) return;
    const d = row.dataset;
    if (shape && d.tip && d.waist && d.tail) {
      shape.setAttribute('d', pathFor(d.tip, d.waist, d.tail));
      drawMeasures(d.tip, d.waist, d.tail);
    }
    plan.querySelectorAll('[data-plan]').forEach((el) => {
      const value = d[el.dataset.plan];
      el.textContent = value || '—';
    });
  };

  const setActive = (row) => {
    rows.forEach((r) => {
      const on = r === row;
      r.classList.toggle('dimensions-table__row--active', on);
      on ? r.setAttribute('aria-current', 'true') : r.removeAttribute('aria-current');
    });
    render(row);
  };

  // Picking a row drives the real picker when there is one, so price, stock
  // and the add-to-cart button all follow; otherwise just update locally.
  const pick = (row) => {
    const input = [...document.querySelectorAll('variant-radios input[type="radio"], variant-selects input[type="radio"]')]
      .find((i) => i.value === row.dataset.size);
    if (input && !input.checked) {
      input.click();
    }
    setActive(row);
  };

  rows.forEach((row) => {
    row.addEventListener('click', () => pick(row));
    row.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        pick(row);
      }
    });
  });

  render(rows.find((r) => r.classList.contains('dimensions-table__row--active')) || rows[0]);

  const listen = () => {
    if (typeof subscribe !== 'function') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data.variant) return;
      const row = rows.find((r) => r.dataset.variantId === String(data.variant.id));
      if (row) setActive(row);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', listen) : listen();
})();
